import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { ResultWrapper, UserAvatar, UserName } from './styles';

class Result extends Component {
  handleClick = () => {
    const { result: { id }, onClick } = this.props;
    onClick(id);
  }

  render() {
    const { result } = this.props;
    return (
      <ResultWrapper onClick={this.handleClick}>
        {result.avatar !== '' ? (
          <UserAvatar alt={result.firstname} src={result.avatar} />
        ) : (
          <UserAvatar className='text-avatar'>
            {result.firstname.slice(0, 1)}
          </UserAvatar>
        )}

        <UserName>
          {`${result.firstname} ${result.lastname}`}
        </UserName>
      </ResultWrapper>
    );
  }
}

Result.propTypes = {
  result: PropTypes.object.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default Result;



// WEBPACK FOOTER //
// ./src/components/Searcher/components/Result.jsx